<template>
	<Tooltip v-if="protocolTcpClient" placement="topLeft"
		:overlayStyle="{ 'max-width': 'min-content' }" color="black">
		<template #title>
			{{ $t('base-stations-edit.tooltips.tcpPort.p1') }}
			<NoLineBreaks>
				<TypographyText code class="tooltip-code">PUBLISH_PORT_AS_IS_START</TypographyText>.
			</NoLineBreaks>
			<NoLineBreaks>
				{{ $t('base-stations-edit.tooltips.tcpPort.p2') }}
				<TypographyText code class="tooltip-code">{{ portMinValue }} - {{ portMaxValue }}</TypographyText>
			</NoLineBreaks>
		</template>
		<QuestionCircleOutlined /> {{ $t('base-stations-edit.fields.port') }}
	</Tooltip>
	<span v-else>{{ $t('base-stations-edit.fields.port') }}</span>
</template>

<script>
import { Tooltip, TypographyText } from 'ant-design-vue';

import { QuestionCircleOutlined } from '@ant-design/icons-vue';

import NoLineBreaks from '@/components/common/NoLineBreaks';


export default {
	components: {
		Tooltip, TypographyText,
		QuestionCircleOutlined,
		NoLineBreaks,
	},
	props: ['protocolTcpClient', 'portMinValue', 'portMaxValue'],
}
</script>
